import React from 'react';
import styles from './EmailHeader.module.css';

interface EmailHeaderProps {
    email: string;
    subject?: string;
    body?: string;
    size?: 'small' | 'medium' | 'large'; 
    color?: string;
}

const EmailHeader: React.FC<EmailHeaderProps> = ({
    email, 
    subject,
    body,
    size = 'medium',
    color = '#DBFF80',
}) => {
    let mailToLink = `mailto:${email}`;
    const params = [];

    if (subject) {
        params.push(`subject=${encodeURIComponent(subject)}`);
    }

    if (body) {
        params.push(`body=${encodeURIComponent(body)}`);
    }

    if (params.length > 0) {
        mailToLink += `?${params.join('&')}`;
    }

    // Determine the class based on the size prop
    const sizeClass = styles[`emailLink_${size}`] || styles.emailLink_medium;

    return (
        <h2>
            <a 
                href={mailToLink} 
                className={sizeClass}
                style={{
                    '--color': color,
                } as React.CSSProperties}
            >
                {email}
            </a>
        </h2>
    );
};

export default EmailHeader;
